<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="800px" scrollable>
            <v-card>
                <v-card-title
                    class="primary white--text align-center"
                    v-if="dialog"
                >
                    {{ plantInventoryNodeObject.plant.name }}

                    <v-chip class="ml-3 mr-1 mb-1" outlined dark>
                        <v-avatar left>
                            <v-icon small>straighten</v-icon>
                        </v-avatar>
                        {{
                            plantInventoryNodeObject.potSize
                                ? plantInventoryNodeObject.potSize.potSizeCm
                                : "-"
                        }}cm
                    </v-chip>
                    <v-chip class="mr-1 mb-1" outlined dark>
                        <v-avatar left>
                            <v-icon small>color_lens</v-icon>
                        </v-avatar>
                        {{
                            plantInventoryNodeObject.color
                                ? plantInventoryNodeObject.color.color
                                : "-"
                        }}
                    </v-chip>
                    <v-chip class="mr-1 mb-1" outlined dark>
                        <v-avatar left>
                            <v-icon small>blur_on</v-icon>
                        </v-avatar>
                        {{
                            plantInventoryNodeObject.environment
                                ? plantInventoryNodeObject.environment
                                      .environment
                                : "-"
                        }}
                    </v-chip>
                    <v-chip class="mr-1 mb-1" outlined dark>
                        <v-avatar left>
                            <v-icon small>turned_in_not</v-icon>
                        </v-avatar>
                        {{
                            plantInventoryNodeObject.tag
                                ? plantInventoryNodeObject.tag.tag
                                : "-"
                        }}
                    </v-chip>
                    <v-spacer />
                    <v-btn icon dark @click="closeMainDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :loading="
                            $apollo.queries.tenantPlantInventoryByWeek.loading
                        "
                        :items="tenantPlantInventoryByWeek.edges"
                        :options.sync="dataTableOptions"
                        loading-text="Loading... Please wait"
                        :items-per-page="defaultItemsPerPage"
                        hide-default-footer
                    >
                        <template
                            v-slot:item.node.readySalesWeekStartDate="{
                                item
                            }"
                        >
                            <span
                                >{{
                                    item.node.readySalesWeekStartDate
                                        | moment("YYYY-[W]WW")
                                }}
                            </span>
                        </template>

                        <template
                            v-slot:item.node.readySalesInventory="{
                                item
                            }"
                        >
                            <span class="mr-5"
                                >{{ item.node.readySalesInventory }}
                            </span>
                        </template>

                        <template
                            v-slot:item.node.orderedInventory="{
                                item
                            }"
                        >
                            <v-icon
                                color="warning"
                                small
                                left
                                v-if="item.node.notEnoughInventoryAlert"
                                >warning</v-icon
                            >
                            <span class="mr-5"
                                >{{ item.node.orderedInventory }}
                            </span>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import moment from "moment";

export default {
    name: "plant-weekly-inventory-dialog",
    props: ["dialog", "plantInventoryNodeObject"],
    components: {},

    apollo: {
        tenantPlantInventoryByWeek: {
            query: gql`
                query tenantPlantInventoryByWeek(
                    $first: Int
                    $plantId: ID
                    $potSizeId: ID
                    $colorId: ID
                    $environmentId: ID
                    $tagId: ID
                    $orderBy: String
                ) {
                    tenantPlantInventoryByWeek(
                        first: $first
                        plant_Id: $plantId
                        potSize_Id: $potSizeId
                        colorId: $colorId
                        environment_Id: $environmentId
                        tag_Id: $tagId
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        edges {
                            node {
                                id
                                readySalesWeekStartDate
                                readySalesYearWeek
                                readySalesInventory
                                orderedInventory
                                notEnoughInventoryAlert
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 100,
                    orderBy: "readySalesWeekStartDate",
                    plantId: this.plantInventoryNodeObject.plant.id,
                    potSizeId: this.plantInventoryNodeObject.potSize
                        ? this.plantInventoryNodeObject.potSize.id
                        : null,
                    colorId: this.plantInventoryNodeObject.color
                        ? this.plantInventoryNodeObject.color.id
                        : null,
                    environmentId: this.plantInventoryNodeObject.environment
                        ? this.plantInventoryNodeObject.environment.id
                        : null,
                    tagId: this.plantInventoryNodeObject.tag
                        ? this.plantInventoryNodeObject.tag.id
                        : null
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            // update: data => data.tenantPlantInventoryByWeek,
            update: data => {
                let _currentWeek = moment().isoWeekday(1);

                let _result = { edges: [] };

                for (let i = 0; i <= 53; i++) {
                    let _x = data.tenantPlantInventoryByWeek.edges.find(
                        item => {
                            return (
                                item.node.readySalesWeekStartDate ==
                                _currentWeek.format("YYYY-MM-DD")
                            );
                        }
                    );

                    if (_x) {
                        _result.edges.push(_x);
                    } else {
                        _result.edges.push({
                            node: {
                                id: _currentWeek.format("YYYY-MM-DD"),
                                readySalesWeekStartDate: _currentWeek.format(
                                    "YYYY-MM-DD"
                                ),
                                readySalesYearWeek: _currentWeek.format(
                                    "YYYY-WW"
                                ),
                                readySalesInventory: 0,
                                orderedInventory: 0,
                                notEnoughInventoryAlert: false
                            }
                        });
                    }

                    _currentWeek = _currentWeek.add(1, "week");
                }

                // console.log("_result: ", _result);

                // return data.tenantPlantInventoryByWeek;
                return _result;
            },
            skip() {
                return !this.dialog;
            }

            // pollInterval: 300 // ms
        }
    },

    data: function() {
        return {
            defaultItemsPerPage: 100,
            dataTableOptions: {},

            tenantPlantInventoryByWeek: {},

            headers: [
                {
                    text: "Week",
                    value: "node.readySalesWeekStartDate",
                    sortable: true
                },
                {
                    text: "Availability",
                    value: "node.readySalesInventory",
                    align: "right",
                    sortable: true
                },
                {
                    text: "Ordered",
                    value: "node.orderedInventory",
                    align: "right",
                    sortable: true
                }
            ]
        };
    },
    computed: {
        weeks() {
            return Array(53)
                .fill(0)
                .map((_, i) => i + 1);
        }
    },
    watch: {},
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        closeMainDialog() {
            this.tenantPlantInventoryByWeek = {};
            this.$emit("update:dialog", false);
            this.$emit("update:plantInventoryNodeObject", null);
        }
    }
};
</script>